import React, { PureComponent } from 'react';
import classNames from 'classnames';
import Svg from 'rp-react-svg-icon';

import DamDetails from './DamDetails';
import StallionDetails from './StallionDetails';
import GenericDetails from './GenericDetails';
import { getHorseType } from '../../utils/horse';

const stallionKeys = ['trainerUid', 'ownerUid', 'sireComment'];
const genericKeys = ['sireUid', 'damUid', 'damSireUid'];
const requiredKeys = [
    'horseDateOfBirth',
    'horseSexCode',
    'breederName',
    ...genericKeys,
    ...stallionKeys,
];

const isExtraDataPresent = (data, isSire) => (isSire ? stallionKeys : genericKeys)
    .every(key => data[key]);

const getTypeSpecificDetails = (props, type) => {
    if (type === 'sire') { return <StallionDetails {...props} />; }
    if (type === 'dam') { return <DamDetails {...props} />; }
    return <GenericDetails {...props} />;
};

class Details extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            expanded: false,
        };
        this.isEmpty = requiredKeys.every(key => !props[key]);

        const type = getHorseType(props);
        this.typeSpecificDetails = getTypeSpecificDetails(props, type);
        this.isExtraDataPresent = isExtraDataPresent(props, type === 'sire');
    }

    toggleDetails = () => {
        this.setState(state => ({ expanded: !state.expanded }));
    }

    render() {
        return this.isEmpty ? null : (
            <div
                className={classNames(
                    'hp-details',
                    this.state.expanded && 'hp-details__expanded'
                )}
            >
                { this.typeSpecificDetails }
                {this.isExtraDataPresent && (
                    <button
                        className="ui-btn hidden-md-up hp-details__expandBtn"
                        onClick={this.toggleDetails}
                    >
                        <Svg iconName="down" size="Medium" />
                    </button>
                )}
            </div>
        );
    }
}

export default Details;



// WEBPACK FOOTER //
// ./src/js/horse/details/Details.jsx